export const CREATE_USER_FORM = {
  username: "",
  password: "",
  confirmPassword: "",
  role: "operador",
};